import {
	HIGH_SCORE_CONFETTI_EMIT_DELAY_MS,
	HIGH_SCORE_CONFETTI_PIECES,
} from '@/features/bouncySums/utils/highScoreConfetti';

import type { CSSProperties } from 'react';
import type { HighScoreConfettiPiece } from '@/features/bouncySums/utils/highScoreConfetti';

const getHighScoreConfettiStyle = (piece: HighScoreConfettiPiece) =>
	({
		'--confetti-color': piece.color,
		'--confetti-delay': `${HIGH_SCORE_CONFETTI_EMIT_DELAY_MS}ms`,
		'--confetti-duration': `${piece.duration}ms`,
		'--confetti-end-x': `${piece.endX}px`,
		'--confetti-end-y': `calc(100vh + ${piece.endY}px)`,
		'--confetti-peak-x': `${piece.peakX}px`,
		'--confetti-peak-y': `${piece.peakY}px`,
		'--confetti-rotation': `${piece.rotation}deg`,
		'--confetti-size': `${piece.size}px`,
		'--confetti-start-x': `${piece.startX}px`,
		'--confetti-start-y': `${piece.startY}px`,
		'--confetti-stretch': piece.stretch,
	} as CSSProperties);

const BouncySumsHighScoreConfetti = () => {
	return (
		<div className="bouncy-sums-end-screen__high-score-confetti" aria-hidden="true">
			{HIGH_SCORE_CONFETTI_PIECES.map((piece, index) => (
				<span
					key={`${piece.peakX}-${piece.peakY}-${index}`}
					className="bouncy-sums-end-screen__high-score-confetti-piece"
					style={getHighScoreConfettiStyle(piece)}
				/>
			))}
		</div>
	);
};

export default BouncySumsHighScoreConfetti;
